export default {
  "ABC": 61697,
  "add-subscription": 61698,
  "adventist-beliefs": 61699,
  "adventist-library": 61700,
  "all-collections": 61701,
  "anchor": 61702,
  "arrow-diagonal": 61703,
  "arrow-right": 61704,
  "audio-books": 61705,
  "AZ": 61706,
  "backups": 61707,
  "bible": 61708,
  "bibliography": 61709,
  "bold-text": 61710,
  "book-circle": 61711,
  "book-close": 61712,
  "book-open": 61713,
  "book-stack": 61714,
  "bookmark-outline": 61715,
  "bookmark": 61716,
  "books": 61717,
  "bookshelf": 61718,
  "bracers": 61719,
  "burger-menu": 61720,
  "calendar": 61721,
  "cart": 61722,
  "chevron-double-left": 61723,
  "chevron-double-right": 61724,
  "chevron-down": 61725,
  "chevron-left": 61726,
  "chevron-right": 61727,
  "chevron-up-circle": 61728,
  "chevron-up": 61729,
  "childrens-stories": 61730,
  "christ-s-life-and-ministry": 61731,
  "christian-lifestyle": 61732,
  "church-history": 61733,
  "church-life-and-ministry": 61734,
  "clip": 61735,
  "close": 61736,
  "commentaries": 61737,
  "concordances": 61738,
  "conflict-of-the-ages-series": 61739,
  "contact-us": 61740,
  "content": 61741,
  "copy-link": 61742,
  "copy": 61743,
  "delete": 61744,
  "devotional-readings": 61745,
  "devotionals": 61746,
  "dictionaries": 61747,
  "dictionary": 61748,
  "donate": 61749,
  "dots-vertical": 61750,
  "download": 61751,
  "edit": 61752,
  "education": 61753,
  "egw-biography": 61754,
  "ellen-dark": 61755,
  "ellen-light": 61756,
  "email-circle": 61757,
  "epub-file": 61758,
  "epub": 61759,
  "evangelism-and-witnessing": 61760,
  "extend": 61761,
  "facebook-circle": 61762,
  "facebook": 61763,
  "faq": 61764,
  "file": 61765,
  "filter": 61766,
  "folder-add": 61767,
  "folder-close": 61768,
  "folder-copy-to": 61769,
  "folder-import": 61770,
  "folder-move-to": 61771,
  "folder-open": 61772,
  "folder-shared": 61773,
  "folder-up": 61774,
  "font": 61775,
  "fullscreen-exit": 61776,
  "fullscreen": 61777,
  "go-to-full-app": 61778,
  "go-to-reader": 61779,
  "google-translate": 61780,
  "grid-2": 61781,
  "grid": 61782,
  "health-and-wellness": 61783,
  "heart-outline": 61784,
  "helping-guides": 61785,
  "highlight": 61786,
  "history-of-redemption": 61787,
  "history": 61788,
  "home": 61789,
  "info-circle": 61790,
  "info": 61791,
  "information": 61792,
  "insta": 61793,
  "install": 61794,
  "italic-text": 61795,
  "L2h": 61796,
  "L2v": 61797,
  "L3h": 61798,
  "L3s12": 61799,
  "L3s12v": 61800,
  "L3s21": 61801,
  "L3s21v": 61802,
  "L3v": 61803,
  "L4h": 61804,
  "L4s112": 61805,
  "L4s112v": 61806,
  "L4s121": 61807,
  "L4s121v": 61808,
  "L4s211": 61809,
  "L4s211v": 61810,
  "L4s22": 61811,
  "L4v": 61812,
  "L5s122": 61813,
  "L5s122v": 61814,
  "L5s2111": 61815,
  "L5s2111v": 61816,
  "L5s212": 61817,
  "L5s212v": 61818,
  "L5s221": 61819,
  "L5s221v": 61820,
  "L6h": 61821,
  "L6v": 61822,
  "L7s1222": 61823,
  "L7s1222v": 61824,
  "L7s2122": 61825,
  "L7s2122v": 61826,
  "L7s2212": 61827,
  "L7s2212v": 61828,
  "L7s2221": 61829,
  "L7s2221v": 61830,
  "L8h": 61831,
  "L8v": 61832,
  "languages": 61833,
  "last-day-events": 61834,
  "layouts": 61835,
  "leadership": 61836,
  "left-arrow": 61837,
  "lessons-from-the-bible": 61838,
  "lessons": 61839,
  "letters-manuscripts": 61840,
  "list": 61841,
  "logo-review-and-herald": 61842,
  "logo": 61843,
  "manuscript": 61844,
  "menu": 61845,
  "microphone": 61846,
  "minus": 61847,
  "misc-collections": 61848,
  "misc-titles": 61849,
  "mobi-file": 61850,
  "modern-english": 61851,
  "move": 61852,
  "mp3-file": 61853,
  "my-library": 61854,
  "new-tab": 61855,
  "note": 61856,
  "old": 61857,
  "page-breaks": 61858,
  "page-numbers": 61859,
  "pamphlets": 61860,
  "paper-study-center": 61861,
  "parenting": 61862,
  "pause-circle": 61863,
  "pause": 61864,
  "pdf-file": 61865,
  "pdf": 61866,
  "periodicals": 61867,
  "pin": 61868,
  "pinterest": 61869,
  "planet-search": 61870,
  "planet": 61871,
  "play-circle": 61872,
  "play-header": 61873,
  "play": 61874,
  "playback-rate": 61875,
  "plus": 61876,
  "preview": 61877,
  "print-circle": 61878,
  "print": 61879,
  "profile": 61880,
  "publishing": 61881,
  "qr-code-header": 61882,
  "qr-code-mobile-menu": 61883,
  "qr-code": 61884,
  "question": 61885,
  "read": 61886,
  "reader-arrow": 61887,
  "reading-history": 61888,
  "recent-authors": 61889,
  "reference-works": 61890,
  "reference": 61891,
  "relationships-and-marriage": 61892,
  "research-documents": 61893,
  "restart": 61894,
  "result-size": 61895,
  "save": 61896,
  "sda-scripture-Index": 61897,
  "search-book": 61898,
  "search-clear": 61899,
  "search-corrections": 61900,
  "search-featured": 61901,
  "search-header": 61902,
  "search-history": 61903,
  "search-phrase": 61904,
  "search-relation": 61905,
  "search-shortcut": 61906,
  "search-suggestions": 61907,
  "search-text": 61908,
  "search": 61909,
  "settings": 61910,
  "share": 61911,
  "show-headers": 61912,
  "sign-in": 61913,
  "skip-back": 61914,
  "skip-forward": 61915,
  "sort-by-recent": 61916,
  "sort": 61917,
  "star": 61918,
  "stop": 61919,
  "study-center-cap": 61920,
  "study-center-plus": 61921,
  "study-center": 61922,
  "study-guides": 61923,
  "subscription-outline": 61924,
  "subscription": 61925,
  "sync-with-feature-search": 61926,
  "sync-with-player": 61927,
  "sync": 61928,
  "telegram-circle": 61929,
  "testimonies-for-the-church": 61930,
  "text-center": 61931,
  "text-decrease": 61932,
  "text-increase": 61933,
  "text-justify": 61934,
  "text-left": 61935,
  "text-right": 61936,
  "the-light-and-life-collection": 61937,
  "theme-select": 61938,
  "timer-disabled": 61939,
  "timer": 61940,
  "titles": 61941,
  "topical-index": 61942,
  "translation": 61943,
  "tree": 61944,
  "twitter-circle": 61945,
  "twitter": 61946,
  "typo": 61947,
  "underline-text": 61948,
  "unshare": 61949,
  "view": 61950,
  "volume-muted": 61951,
  "volume": 61952,
  "whatsapp-circle": 61953,
  "youth-and-modern-english": 61954,
  "youtube-circle": 61955,
  "youtube": 61956,
};
